<script lang="ts" setup></script>

<template>
  <main>
    <RouterView />
  </main>
</template>
